import emitter from 'scripts/utils/emitter'
import * as cartRepository from 'scripts/api/cart'

import { hideSpinner, showSpinner } from 'utils/Spinner'

export { default as dataLayer } from './data-layer'

export const updateCartQuantity = ({ count }) =>
  emitter.emit('cart:update', { count })

export const cartProductAdded = cart =>
  emitter.emit('cart:products-replace', cart)

export const callApiAndUpdateCart = async () => {
  const {
    data: {
      shippings,
      uniqueProductsCount,
      total,
      subTotal,
      discountTotal,
      cheapestPayMethodTotal,
      paymentMethodsSummary,
      paymentMethods,
      servicesSubTotal,
      totalInstallments,
      totalDiscountsByType,
      firstCheapestPaymentMethod
    }
  } = await cartRepository.getCart()

  cartProductAdded({
    shippings,
    uniqueProductsCount,
    total,
    subTotal,
    discountTotal,
    cheapestPayMethodTotal,
    paymentMethodsSummary,
    paymentMethods,
    servicesSubTotal,
    totalInstallments,
    totalDiscountsByType,
    firstCheapestPaymentMethod
  })

  updateCartQuantity({ count: uniqueProductsCount })
}

export const handleSpinner = ({ useSpinner = false, action = 'hide' }) => {
  if (!useSpinner) return

  action === 'show' ? showSpinner() : hideSpinner()
}
